// The rails' icons are 16px, a step up from the shared `md` (14px) that suits 40px chrome.
export const RAIL_ICON_SIZE_CLASS = "!h-4 !w-4 !min-h-4 !min-w-4";
